export default {
    auth : {
        token : null,
        restaurantId : null,
        restaurantName : null,
        isLogin : false,
        userName : null,
        expiredDate : null
    }
}